if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');

			this.pickupAvailabilityExtended = this.querySelector('pickup-availability-extended');

			// Gallery thumbnails

			if ( this.productSlider ) {

				const productGaleryThumbnails = this.querySelector('.product-gallery__thumbnails-holder');

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i == 0 )  {
							elm.classList.add('active');
						}
						elm.addEventListener('click',e=>{
							if ( this.productSlider.sliderEnabled ) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).getBoundingClientRect().top,
									behavior: 'smooth'
								});
								this.thumbnailNavigationHelper(e.currentTarget.dataset.index);
							}
							this._pauseAllMedia();
							this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`));
							productGaleryThumbnails.scrollTo({
								left: elm.offsetLeft - 50,
								behaviour: 'smooth'
							})
						});
					})

					this.productSlider.addEventListener('change', e=>{
						this.thumbnailNavigationHelper(e.target.index);
					});

				}

				this.productSlider.addEventListener('navigation', e=>{
					this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`));
				})
				this.productSlider.addEventListener('change', e=>{
					this._pauseAllMedia();
					if ( this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				// Parallax

				this.productSlider.addEventListener('ready', (e)=>{
					if ( this.firstProductGalleryIndex ) {
						this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
					}
				});

			}

			// Show more button under product gallery
			const showMoreButton = document.getElementById('show-more-button');
			if ( showMoreButton ) {
				const showMoreText = showMoreButton.dataset?.showMoreText;
				const showLessText = showMoreButton.dataset?.showLessText;
				const hiddenItems = document.querySelectorAll('.product-gallery-item.element--hide-on-desk');

				showMoreButton.addEventListener('click', function() {
					hiddenItems.forEach(item => {
						item.classList.toggle('element--hide-on-desk');
					});

					if(showMoreButton.textContent.trim() === showMoreText) {
						showMoreButton.textContent = showLessText;
					} else {
							showMoreButton.textContent = showMoreText;
						}
				});
			}

			const showMoreDescButton = document.getElementById('show-product-description');
			if ( showMoreDescButton ) {
				const showMoreDescText = showMoreDescButton.dataset?.showMoreText;
				const showLessDescText = showMoreDescButton.dataset?.showLessText;
				const hiddenDescItems = document.querySelectorAll('.product-description__content.hidden');

				showMoreDescButton.addEventListener('click', function() {
					hiddenDescItems.forEach(item => {
						item.classList.toggle('hidden');
					});

					if(showMoreDescButton.textContent.trim() === showMoreDescText) {
						showMoreDescButton.textContent = showLessDescText;
					} else {
						showMoreDescButton.textContent = showMoreDescText;
					}
				});
			}
			// Product variant event listener for theme specific logic

			this.productVariants = this.querySelector('product-variants[data-main-product-variants]');
			if ( this.productVariants ) {

				this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this.onVariantChangeHandler({target:this.productVariants});

				// refresh color
				this.querySelectorAll('.product-variant__item--radio input').forEach(input=>{
					input.addEventListener('click', () => {
						const inputParent = input.closest('.product-variant__item--radio');
						if ( inputParent.classList.contains('product-variant__item--color' ) ) {
							inputParent.closest('.product-variant').querySelector('.product-variant__item-text-label').textContent = input.value;
						}
					})
				});

			}

			// show cart drawer when element is added to cart

			if ( ! document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay' ) {

				let addToCartEnter = false;
				if ( this.querySelector('[data-js-product-add-to-cart]') ) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							addToCartEnter = true;
						}
					})
				}

				if ( this.querySelector('[data-js-product-form]') ) {
					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
						document.getElementById('site-cart-sidebar').show();
						if ( document.getElementById('cart-recommendations-sidebar') ) {
							document.getElementById('cart-recommendations-sidebar').generateRecommendations();
						}
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('#site-cart-sidebar [data-js-close]').focus();
							}, 200);
						}
					});
				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			// hide buy now button if stock disabled

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart][data-main-product-add-to-cart]');
			if ( addToCartButton ) {
				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				const buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
			}

		}

		thumbnailNavigationHelper(index=0){
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
				if ( i == index )
					elm.classList.add('active');
				else
					elm.classList.remove('active');
			});
		}

		onVariantChangeHandler(e){

			let variant = e.target.currentVariant;
			if ( variant ) {

				// image handling

				if ( variant.featured_media != null ) {
					let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
					if ( variantImg ) {
						if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
							if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
								this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
							} else {
								this.firstProductGalleryIndex = variantImg.dataset.index;
							}
						} else {
							if ( variantImg.getBoundingClientRect().top > window.innerHeight ) {
								variantImg.scrollIntoView({behavior: 'smooth', block: 'center'});
							} else if ( variantImg.getBoundingClientRect().top < 0 ) {
								variantImg.scrollIntoView({behavior: 'smooth', block: 'center'});
							}
						}
					}
				}

				this.querySelectorAll('.product-variant__item--color [data-selected]').forEach(elm=>{
					elm.closest('.product-variant').querySelector('.product-variant__item-text-label').textContent = elm.value;
				});

			}

		}

		_pauseAllMedia(){

			document.querySelectorAll('.product-gallery .js-youtube').forEach(video => {
				video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
			});
			document.querySelectorAll('.product-gallery .js-vimeo').forEach(video => {
				video.contentWindow.postMessage('{"method":"pause"}', '*');
			});
			document.querySelectorAll('.product-gallery video').forEach(video => video.pause());
			document.querySelectorAll('.product-gallery product-model').forEach(model => {
				if ( model.modelViewerUI )
					model.modelViewerUI.pause()
			});
		}

		_playMedia(media){
			switch ( media.dataset.productMediaType ) {
				case 'video':
					if ( media.querySelector('video') ) {
						media.querySelector('video').play();
					}
					break;
				case 'external_video-youtube':
					if ( media.querySelector('.js-youtube') ) {
						media.querySelector('.js-youtube').contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
					}
					break;
				case 'external_video-vimeo':
					if ( media.querySelector('.js-vimeo') ) {
						media.querySelector('.js-vimeo').contentWindow.postMessage('{"method":"play"}', '*');
					}
					break;
			}
		}

	}

	if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}

document.addEventListener('DOMContentLoaded', function() {

	function _formatMoney(cents, format) {

		if (typeof cents === 'string') {
			cents = cents.replace('.', '');
		}

		let value = '';
		const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		const formatString = format || moneyFormat;

		function formatWithDelimiters(number, precision, thousands, decimal) {
			thousands = thousands || ',';
			decimal = decimal || '.';

			if (isNaN(number) || number === null) {
				return 0;
			}

			number = (number / 100.0).toFixed(precision);

			const parts = number.split('.');
			const dollarsAmount = parts[0].replace(
				/(\d)(?=(\d\d\d)+(?!\d))/g,
				'$1' + thousands
			);
			const centsAmount = parts[1] ? decimal + parts[1] : '';

			return dollarsAmount + centsAmount;
		}

		switch (formatString.match(placeholderRegex)[1]) {
			case 'amount':
				value = formatWithDelimiters(cents, 2);
				break;
			case 'amount_no_decimals':
				value = formatWithDelimiters(cents, 0);
				break;
			case 'amount_with_comma_separator':
				value = formatWithDelimiters(cents, 2, '.', ',');
				break;
			case 'amount_no_decimals_with_comma_separator':
				value = formatWithDelimiters(cents, 0, '.', ',');
				break;
			case 'amount_no_decimals_with_space_separator':
				value = formatWithDelimiters(cents, 0, ' ');
				break;
			case 'amount_with_apostrophe_separator':
				value = formatWithDelimiters(cents, 2, "'");
				break;
		}

		return formatString.replace(placeholderRegex, value);

	}

	const variantsSelect = document.querySelectorAll('.seo-variants__item button');

	variantsSelect.forEach(variantSelect => {
		if (variantSelect) {
			variantSelect.addEventListener('click', function(event) {
				const buttonElement = variantSelect;
				const productHandle = buttonElement.dataset.productHandle;
				const url = `/products/${productHandle}.js`;

				fetch(url)
					.then(response => {
						if (!response.ok) {
							throw new Error(`HTTP error! Status: ${response.status}`);
						}
						return response.json();
					})
					.then(data => {
						// Make clicked variant active
						const activebutton = document.querySelector('.seo-variants__item.active');
						activebutton?.classList?.remove('active');
						//Remove disabled attribute from button
						activebutton?.querySelector('button')?.removeAttribute('disabled');

						buttonElement.parentNode.parentElement.classList.add('active');
						buttonElement.setAttribute('disabled', 'disabled');

						// Update page elements with variant data
						updateProductDetails(data);

						console.log(data)

					})
					.catch(error => {
						console.error('Error fetching variant data:', error);
					});
			});
		} else {
			console.warn('Variant select element not found with ID "product-select"');
		}
	});

	function renderImage({ imageUrl, fullImageUrl, index }) {
		return `
		<div class="product-gallery-item element--border-radius element--border-radius ${index > 2 && 'element--hide-on-desk'}" data-product-media-type="image" data-product-single-media-wrapper="" data-media-id="39748301750555" data-video="" tabindex="${index}" data-index="${index}" data-image-zoomdata-ratio="1" style="padding-top: 100%">
			${renderImageContent({ imageUrl, fullImageUrl, index })}
		</div>
		`
	}

	function renderImageContent({ imageUrl, fullImageUrl, index }) {
		return `<figure class="lazy-image lazy-image--background lazy-image--to-reveal apply-gallery-animation" data-ratio="1" style="padding-top: 100%" data-crop="false">
				<img src="${imageUrl}" alt="Zapasowe wkłady MIX zapachów do dyfuzora eDrive" ${generateSrcSet({imageUrl})} class="img" width="4500" height="4500" data-ratio="1" sizes="(max-width: 767px) 100vw, (max-width: 1024px) 60vw, (max-width: 1360px) 33vw, 453px" onload="this.parentNode.classList.add('lazyloaded');imageReveal.observe(this.parentNode);">
			</figure>
			<product-image-zoom class="product-gallery-item__zoom" data-image="${fullImageUrl}" aria-hidden="true" tabindex="-1">
				<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="9.08008" cy="9" r="8" stroke="var(--main-text)" stroke-width="2" style="fill:none!important"></circle><rect x="14.2988" y="15.9062" width="1.98612" height="6.65426" transform="rotate(-45 14.2988 15.9062)" fill="#111111"></rect><path d="M8.08008 5H10.0801V13H8.08008V5Z" fill="#111111"></path><path d="M13.0801 8V10L5.08008 10L5.08008 8L13.0801 8Z" fill="#111111"></path></svg>
			</product-image-zoom>`
	}

	function generateSrcSet({imageUrl}) {
		return `${imageUrl}?crop=center&height=240&width=240 240w,${imageUrl}?crop=center&height=360&width=360 360w,${imageUrl}?crop=center&height=420&width=420 420w,${imageUrl}?crop=center&height=480&width=480 480w,${imageUrl}?crop=center&height=640&width=640 640w,${imageUrl}?crop=center&height=840&width=840 840w,${imageUrl}?crop=center&height=1080&width=1080 1080w,${imageUrl}?crop=center&height=1280&width=1280 1280w,${imageUrl}?crop=center&height=1540&width=1540 1540w,${imageUrl}?crop=center&height=1860&width=1860 1860w,${imageUrl}?crop=center&height=2100&width=2100 2100w,${imageUrl}?crop=center&height=2460&width=2460 2460w,${imageUrl}?crop=center&height=2820&width=2820 2820w,${imageUrl}?crop=center&height=3360&width=3360 3360w,${imageUrl}?crop=center&height=3820&width=3820 3820w`
	}

	function generateProductVariants({variants, product, productTitle}) {

		// Create a list of product variants
		const variantsHtml = variants.map((variant, index) => {
			const displayName = variant.option1 == "Default Title" ? productTitle : variant.option1;
			return `<div class="product-variant__item product-variant__item--radio">
				<input type="radio" name="product-objem-template--${product.id}__main" id="${product.handle}-objem-${index}-template--${product.id}__main" value="${variant.option1}" class="product-variant__input product-variant-value" data-available="true" data-option-value-id="${variant.id}" data-variant-id="${variant.id}" ${index === 0 && 'data-selected="" checked=""'}>
					<label for="${product.handle}-objem-${index}-template--${product.id}__main" class="product-variant__label text-size--small">
						<span class="product-variant__selected-circle"></span>
						<span style="display: block;">
						  <span class="text-weight--bold">${displayName}</span> <br>
						  <span class="product-variant__price" style="font-size: 15px">${_formatMoney(variant.price, KROWN.settings.shop_money_format)}</span>
						</span>
					</label>
			</div>`
		})

		return `
			<div class="product-variant" data-name="product-objem-template--${product.id}__main" data-js-product-variant="">
				<div class="product-variant__container product-variant__container--radio product-variant__container--radio--wrap" data-js-product-variant-container="radio">
					${variantsHtml.join('')}
				</div>
			</div>
		`
	}

	// Function to update product details on the page with the new product data
	// First variant selected as default
	function updateProductDetails(product) {
		const productTitle = document.querySelector('.product__title');
		const productDescription = document.querySelector('.product-description__content');
		const productImages = document.querySelectorAll('.product-gallery-item');
		const productImagesContainer = document.querySelector('.product-gallery-container');

		// Update product title
		if (productTitle) productTitle.textContent = product.title; else console.warn('Product title element not found');

		// Update product description
		if (productDescription) productDescription.innerHTML = product.description; else console.warn('Product description element not found');

		// Replace src of first three images with new images
		// And rerender the rest of the images
		if (productImages && productImagesContainer) {
			product.images.forEach((image, index) => {
				if (index > productImages.length - 1) {
					productImagesContainer.innerHTML += renderImage({ imageUrl: image, fullImageUrl: image, index });

					if (index === product.images.length - 1 && productImages.length - 1 > index) {
						// Remove the rest of the images
						productImages.forEach((productImage, i) => {
							if (i > index) {
								productImage.remove();
							}
						});
					}

					return;
				}

				if (index < 3) {
					productImages[index]?.querySelector("img")?.setAttribute('src', image);
					productImages[index]?.querySelector("img")?.setAttribute('srcset', generateSrcSet({imageUrl: image}));
				} else {
					productImages[index].innerHTML = renderImageContent({ imageUrl: image, fullImageUrl: image, index });
				}
			});
		} else {
			console.warn('Product images element not found');
		}


		// Update product variants list with new variants
		const productVariants = document.querySelector('.product-variants');
		const availableVariants = product.variants?.filter(variant => variant.available) ?? [];
		if (productVariants) {
			// Filter out variants that are not available
			productVariants.innerHTML = generateProductVariants({variants: availableVariants, product, productTitle: product.title})
			console.dir({variants: availableVariants, product})
		} else {
			console.warn('Product variants element not found');
		}

		// Overwrite URL with new product URL
		const productUrl = `/products/${product.handle}`;
		window.history.pushState('', '', productUrl);

		const productVariantsElement = document.querySelector('product-variants');
		productVariantsElement?.setAttribute('data-url', productUrl);
		productVariantsElement?.dispatchEvent(new CustomEvent('VARIANT_CHANGE', { target: productVariantsElement }));

		let variantIdContainer = document.querySelector('span[data-update-block="variant-id-main-product"] input');
		let _variantIdContainer = document.querySelector('span[data-update-block="variant-id-installment-main"] input');
		if (variantIdContainer) {
			setTimeout(() => {
				variantIdContainer.value = availableVariants[0].id;
				_variantIdContainer.value = availableVariants[0].id;
			}, 250)
		}

		const allVariants = document.querySelectorAll('.product-variant__item.product-variant__item--radio input');
		allVariants.forEach(variant => {
			variant.addEventListener('click', function(event) {
				setTimeout(() => {
					const currentVariantId = event.target.dataset.variantId;
					if (currentVariantId) {
						variantIdContainer = document.querySelector('span[data-update-block="variant-id-main-product"] input');
						_variantIdContainer = document.querySelector('span[data-update-block="variant-id-installment-main"] input');
						console.log(currentVariantId, variantIdContainer, _variantIdContainer)
						variantIdContainer.value = currentVariantId;
						_variantIdContainer.value = currentVariantId;
					}
				}, 250)
			});
		});

		const productDescriptionsUrl = `/products/${product.handle}?view=variant-data`;

		fetch(productDescriptionsUrl)
			.then(response => response.json())
			.then(variantData => {
				//console.log(variantData)
				const productSubtitle = document.querySelector('#product-subtitle');
				productSubtitle.textContent = variantData['product-subtitle'] ?? '';
				const productDescriptionShort = document.querySelector('#product-description-short');
				productDescriptionShort.innerHTML = `${variantData['product-description-short']}${variantData['product-description-short-html']}`;
			})
			.catch(error => console.error('Error fetching product descriptions:', error));
	}

	const allVariants = document.querySelectorAll('.product-variant__item.product-variant__item--radio input');
	allVariants.forEach(variant => {
		variant.addEventListener('click', function(event) {
			setTimeout(() => {
				const currentVariantId = event.target.dataset.variantId;
				if (currentVariantId) {
					variantIdContainer = document.querySelector('span[data-update-block="variant-id-main-product"] input');
					_variantIdContainer = document.querySelector('span[data-update-block="variant-id-installment-main"] input');
					console.log(currentVariantId, variantIdContainer, _variantIdContainer)
					variantIdContainer.value = currentVariantId;
					_variantIdContainer.value = currentVariantId;
				}
			}, 250)
		});
	});
});

